<template>
  <v-layout row wrap fill-height align-center justify-center class="secondary lighten-1">
    <v-flex xs12 sm4 align-center justify-center>
      <v-card class="secondary lighten-1 elevation-0">
        <v-card-title primary-title>
          <div class="white--text">
            <h3 class="headline mb-0">Select mpx Account</h3>
            <div>to continue</div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-text-field placeholder="Filter accounts" solo clearable hide-details
            @input="value => filterAccounts(value)" prepend-inner-icon="search"></v-text-field>
          <v-list class="account-selection" three-line>
            <v-radio-group v-model="selectedAccount">
              <v-list-tile @click="updateSelection(account)" :key="account.id" v-for="account in filteredAccountsList">
                <v-list-tile-action>
                  <v-radio :value="account"></v-radio>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ account.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>Permissions: {{ accessText(account._service) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-radio-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="$lodash.isEmpty(selectedAccount)" :loading="loadingServiceRegistry"
            @click="navigateToMPX">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"
import AppService from "@/AppService"
import AuthService from "@/Auth/AuthService"
import messages from "@/Auth/messages.json"
import * as appDataService from "@/AppDataService"
import * as authDataService from "@/Auth/AuthDataService"
import { SET_MPX_PARENT_ACCOUNT, SET_SERVICE_REGISTRY, SET_MPX_SUB_ACCOUNTS } from "@/store/constants/mutation-types"
import { GET_MVATS_AUTHORIZE_INFO, GET_OPSUI_AUTHORIZE_INFO } from "@/store/constants/action-types"

export default {
  name: "MPXAccountSelection",
  data() {
    return {
      loadingServiceRegistry: false,
      accountsList: [],
      filteredAccountsList: [],
      selectedAccount: {}
    }
  },
  computed: {
    ...mapState(["mvatsAuthorizeInfo", "opsUIAuthorizeInfo", "mpxParentAccount"])
  },
  methods: {
    ...mapMutations([
      SET_MPX_PARENT_ACCOUNT, SET_SERVICE_REGISTRY, SET_MPX_SUB_ACCOUNTS
    ]),
    ...mapActions([
      GET_MVATS_AUTHORIZE_INFO, GET_OPSUI_AUTHORIZE_INFO
    ]),

    /**
     * updateSelection -
     * @param {object} account
     */
    updateSelection(account) {
      this.selectedAccount = account
    },

    /**
     * getAccountsList
     */
    getAccountsList() {
      let mvatsAccounts = []
      let opsUIAccounts = []

      if (!this.$lodash.isUndefined(this.mvatsAuthorizeInfo.accounts) && this.mvatsAuthorizeInfo.accounts.length > 0) {
        mvatsAccounts = this.$lodash.cloneDeep(this.mvatsAuthorizeInfo.accounts)
      }
      if (!this.$lodash.isUndefined(this.opsUIAuthorizeInfo.accounts) && this.opsUIAuthorizeInfo.accounts.length > 0) {
        opsUIAccounts = this.$lodash.cloneDeep(this.opsUIAuthorizeInfo.accounts)
      }

      let commonAccounts = this.$lodash.intersectionBy(mvatsAccounts, opsUIAccounts, "id")
      let mvatsFiltered = this.$lodash.pullAllBy(mvatsAccounts, commonAccounts, "id")
      let opsUIFiltered = this.$lodash.pullAllBy(opsUIAccounts, commonAccounts, "id")
      // Update service value
      this.$lodash.forEach(commonAccounts, (account) => {
        account["_service"] = [AppService.getMvatsServiceString(), AppService.getOpsUIServiceString()]
      })

      this.accountsList = this.$lodash.concat(commonAccounts, mvatsFiltered, opsUIFiltered)
      this.filteredAccountsList = this.accountsList
    },

    /**
     * accessText
     * @param {array} services
     */
    accessText(services) {
      return AuthService.accessText(services)
    },

    /**
     * navigateToMPX -
     */
    navigateToMPX() {
      let redirectTo = "/home" // Default re-direction
      let isAccountSelected = !this.$lodash.isNull(this.mpxParentAccount) && !this.$lodash.isEmpty(this.mpxParentAccount)
      let isAcccountSelectionChanged = isAccountSelected && (this.mpxParentAccount.id !== this.selectedAccount.id)
      let isFirstSelection = !isAccountSelected && !this.$lodash.isEmpty(this.selectedAccount)
      if (isAcccountSelectionChanged || isFirstSelection) {
        this.loadingServiceRegistry = true
        this.SET_MPX_PARENT_ACCOUNT(this.selectedAccount)
        appDataService
          .setMPXParentAccountInfo(this.selectedAccount)
          .then(() => {
            // Retrieve registry information
            return authDataService.mpxRegistry(this.selectedAccount.pid)
              .then((response) => {
                let services = response.data.entries[0].services
                this.SET_SERVICE_REGISTRY(services)
                return appDataService.setServiceRegistry(services)
              })
          })
          .then(() => {
            // Retrieve sub accounts information
            return authDataService.mpxSubAccounts(this.selectedAccount.id)
              .then((response) => {
                let subAccounts = response.data.entries
                this.SET_MPX_SUB_ACCOUNTS(subAccounts)
                return appDataService.setMPXSubAccounts(subAccounts)
              })
          })
          .then(() => {
            AppService.$emit("event:mpxAccountChanged")
            let redirect = this.$route.query.redirect
            if (!this.$lodash.isUndefined(redirect)) {
              if (redirect.indexOf("metadata-rules") > -1) {
                redirectTo = "/metadata-rules"
              } else {
                redirectTo = this.$route.query.redirect
              }
            }
            this.$router.replace({
              path: redirectTo
            })
          })
          .finally(() => {
            this.loadingServiceRegistry = false
          })
      } else {
        if (!this.$lodash.isUndefined(this.$route.query.redirect)) {
          redirectTo = this.$route.query.redirect
        }
        this.$router.replace({
          path: redirectTo
        })
      }
    },

    /**
     * filterAccounts
     * @param {string} search
     */
    filterAccounts(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "title"
        ]
        this.filteredAccountsList = this.accountsList.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredAccountsList = this.accountsList
      }
    }
  },
  /**
   * Triggered on first entry in to the route /metadata-rules/rule-set
   * @param {object} to
   * @param {object} from
   * @param {Function} next
   */
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedAccount = vm.$lodash.cloneDeep(vm.$store.state.mpxParentAccount)
    })
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initialize
     */
    this.getAccountsList()
  }
}
</script>

<style  lang="scss">
.account-selection {
  min-height: 400px;
  max-height: 400px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/Auth/MPXAccountSelection.vue